import { actionTypes } from '../../../types';

const initialState = {
    loading: false,
    data: null,
    error: null,
    status: null,
    message: null,
};

const saveInfluencerProfileReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SAVE_INFLUENCER_PROFILE_REQUEST:
            return { ...state, loading: true, error: null };
        case actionTypes.SAVE_INFLUENCER_PROFILE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.response,
                status: action.payload.status,
                message: action.payload.message,
                error: null,
            };
        case actionTypes.SAVE_INFLUENCER_PROFILE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.message,
                status: action.payload.status,
                message: action.payload.message,
            };
        case actionTypes.SAVE_INFLUENCER_PROFILE_RESET:
            return { ...state, status: null, message: null };
        case actionTypes.SAVE_INFLUENCER_PROFILE_RESET_ALL:
            return initialState;
        default:
            return state;
    }
};

export default saveInfluencerProfileReducer;
